// extracted by mini-css-extract-plugin
module.exports = {"banner":"TraceBanner_banner__IRnpd","bannerText":"TraceBanner_bannerText__ftA85"};